import Loader from 'components/Layout/Loader';
import React, { useEffect, useState } from 'react';
import { icons, profilePath } from 'utils/constants';
import { generatePreSignedUrl, objectToFormData } from 'utils/helpers';
import './OtherConferencePassesView.scss';
import CheckBox from 'components/form/CheckBox';
import Button from 'components/form/Button';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSingleCommitteeMember,
  sendHallTicketPreference,
  showSuccess,
} from 'store/slices';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';

import axios from 'axios';
import PreviewHallTicketPopup from 'pages/Common/InstantTicketGenerate/PreviewHallTicketPopup';

const OtherConferencePassesView = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { abstract_id } = params;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [committeeMember, setCommitteeMember] = useState({});
  const [s3URL, setS3URL] = useState('');
  const [openHallTicketPopup, setOpenHallTicketPopup] = useState(false);

  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const { view: viewAccess, create: createAccess } =
    userDetails?.role_data?.find(
      (item) => item?.permission_name === 'Instant Ticket Generate'
    )?.sub_permission || {};

  const getSingleCommitteeMember = async () => {
    const response = await dispatch(fetchSingleCommitteeMember(abstract_id));
    if (response?.status === 200) {
      setCommitteeMember(response?.data);
    }
    setIsLoading(false);
  };

  const fetchProfile = async (profileName) => {
    if (profileName) {
      const response = await generatePreSignedUrl(profileName, profilePath);
      setS3URL(response);
    }
  };

  useEffect(() => {
    getSingleCommitteeMember();
  }, [abstract_id]);

  useEffect(() => {
    if (committeeMember?.photo_path) {
      fetchProfile(committeeMember?.photo_path);
    }
  }, [committeeMember?.photo_path]);

  const validationSchema = Yup.object().shape({
    preferences: Yup.object()
      .shape({
        whatsapp: Yup.boolean(),
        email: Yup.boolean(),
      })
      .test(
        'at-least-one-selected',
        'Select at least one option',
        (value) => value?.whatsapp || value?.email
      ),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const { preferences } = values;
    const sendVia = Object.keys(preferences)
      .filter((key) => preferences[key]) // only keep true ones
      .join(',');
    const payload = {
      type: 'commitee',
      id: abstract_id,
      send_via: sendVia,
    };

    const response = await dispatch(
      sendHallTicketPreference(objectToFormData(payload))
    );
    if (response.status === 200) {
      dispatch(showSuccess(response.message));
    }

    setSubmitting(false);
  };

  const handlePrintPDF = async (pdfUrl) => {
    try {
      const response = await axios.get(pdfUrl, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;

      document.body.appendChild(iframe);

      iframe.onload = function () {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      };
    } catch (error) {
      console.error('Error fetching or printing PDF:', error);
    }
  };

  return (
    <div id="otherConferencePassesView">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="general-detail">
            <div
              className="d-flex pb-1"
              onClick={() => {
                navigate(-1);
              }}
            >
              <img
                src={icons.leftArrow}
                alt="back"
                className="h-21 me-3 pointer"
              />
            </div>
            <div className="basic-detail">
              <img
                src={s3URL || icons.profileImg}
                alt="User"
                className="user-img"
              />
              <div>
                <h4>{committeeMember?.user_name}</h4>
                <div className="contact-info">
                  <div>
                    <img src={icons.emailIcon} alt="Icon" />
                    <span>{committeeMember?.email_id}</span>
                  </div>
                  <div>
                    <img src={icons.callIcon} alt="Icon" />
                    <span>
                      {committeeMember?.phone_code}{' '}
                      {committeeMember?.phone_number}
                    </span>
                  </div>
                  {committeeMember?.county && (
                    <div>
                      <img src={icons.earthIcon} alt="Icon" />
                      <span>{committeeMember?.county}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="conference-info">
              <h4>Conference & Abstract Info :</h4>
              <div className="detail">
                <div className="full-width">
                  <h5>Conference Name :</h5>
                  <p>{committeeMember?.event_name}</p>
                </div>
                <div className="third-width">
                  <h5>Committe Member Type :</h5>
                  <p>{committeeMember?.attendee_type}</p>
                </div>
                <div className="third-width">
                  <h5>University :</h5>
                  <p>{committeeMember?.university}</p>
                </div>
                <div className="third-width">
                  <h5>Designation :</h5>
                  <p>{committeeMember?.designation}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row gx-3">
            <div className="col-xl-12">
              {committeeMember?.hall_ticket_url ? (
                <div className="other-detail hall-ticket-div">
                  <h5>Hall Ticket</h5>

                  <Formik
                    initialValues={{
                      preferences: {
                        whatsapp: false,
                        email: false,
                      },
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleSubmit,
                      setFieldValue,
                      isSubmitting,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-3">
                            <div className="text-14-400-18 cmb-14">
                              Pass Send Via:
                            </div>
                            <div className="d-flex gap-3">
                              <div className="d-flex align-items-center gap-2">
                                <CheckBox
                                  type="ACTIVE"
                                  isChecked={values.preferences.whatsapp}
                                  onClick={() =>
                                    setFieldValue(
                                      'preferences.whatsapp',
                                      !values.preferences.whatsapp
                                    )
                                  }
                                />
                                <span className="text-black-olive text-14-300-18">
                                  Whats App
                                </span>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                <CheckBox
                                  type="ACTIVE"
                                  isChecked={values.preferences.email}
                                  onClick={() =>
                                    setFieldValue(
                                      'preferences.email',
                                      !values.preferences.email
                                    )
                                  }
                                />
                                <span className="text-black-olive text-14-300-18">
                                  E-Mail
                                </span>
                              </div>
                            </div>
                            {touched.preferences && errors.preferences && (
                              <div className="text-danger text-13 mt-2">
                                {errors.preferences}
                              </div>
                            )}
                          </div>

                          <div className="col-md-3">
                            <div className="text-14-400-18 cmb-14">
                              Hall Ticket:
                            </div>
                            {viewAccess === '1' && (
                              <button
                                className="preview-btn"
                                type="button"
                                onClick={() => setOpenHallTicketPopup(true)}
                              >
                                <img src={icons.blueEyeIcon} alt="Icon" />
                                Preview Ticket
                              </button>
                            )}
                          </div>
                        </div>

                        {createAccess === '1' && (
                          <div className="d-flex align-items-center gap-2 cmb-20">
                            <Button
                              text="Send"
                              btnStyle="primary-dark"
                              className="h-35 cps-20 cpe-20 mt-3"
                              type="submit"
                              btnLoading={isSubmitting}
                              disabled={isSubmitting}
                            />
                            <Button
                              text="Print"
                              btnStyle="primary-outline"
                              className="h-35 cps-20 cpe-20 mt-3"
                              disabled={isSubmitting}
                              onClick={() =>
                                handlePrintPDF(committeeMember?.hall_ticket_url)
                              }
                            />
                          </div>
                        )}
                      </form>
                    )}
                  </Formik>
                </div>
              ) : (
                <div className="other-detail hall-ticket-div">
                <p className="text-14-400-18 color-red">
                  Note: Still Pass Not Generated
                </p>
                </div>
              )}
            </div>
          </div>
          {openHallTicketPopup && (
            <PreviewHallTicketPopup
              onHide={() => setOpenHallTicketPopup(false)}
              pdfUrl={committeeMember?.hall_ticket_url}
            />
          )}
        </>
      )}
    </div>
  );
};

export default OtherConferencePassesView;
